var map = {
	"./news1.jpg": "fd03",
	"./news10.jpg": "3106",
	"./news11.jpg": "a63e",
	"./news12.jpg": "6a72",
	"./news13.jpg": "894b",
	"./news14.jpg": "33fd",
	"./news15.png": "b1c9",
	"./news16.jpg": "021d",
	"./news17.jpg": "55b0",
	"./news18.png": "d73a",
	"./news19.jpg": "34bd",
	"./news2.jpg": "58b2",
	"./news3.jpg": "dc0f",
	"./news4.jpg": "56d0",
	"./news5.jpg": "467b",
	"./news6.jpg": "935b",
	"./news7.jpg": "7b8c",
	"./news8.jpg": "6ef2",
	"./news9.jpg": "9a7f",
	"./news_img.jpg": "8d53",
	"./news_poster0.jpg": "246e",
	"./news_poster1.jpg": "36a6",
	"./news_poster2.png": "d59b",
	"./news_poster3.png": "713b",
	"./news_poster4.png": "61d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9400";